import { ShortcutSettings } from '@/features/shortcut-settings';
import { SettingsShell } from '@/features/settings-shell';

import styles from './AccountPage.module.css';

/** Settings -> Keyboard shortcuts. */
export function ShortcutsPage() {
  return (
    <SettingsShell>
      <div className={styles.page}>
        <ShortcutSettings />
      </div>
    </SettingsShell>
  );
}
